import { render, staticRenderFns } from "./CoreChangeLogDetail.vue?vue&type=template&id=1bc752bb&scoped=true"
import script from "./CoreChangeLogDetail.vue?vue&type=script&lang=js"
export * from "./CoreChangeLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc752bb",
  null
  
)

export default component.exports